/**
 * @Author: v_jppjpeng
 * @Date: 2023-12-15 11:18:13
 * @Explain: 复制功能
 */
import { Button, Icon, Link, notification } from '@/components/tdesign';
import { intlGet } from '@/locales';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import { LinkProps } from 'tdesign-react';
import { ButtonPropsType } from '../data.d';

type PropsType = {
  children?: ReactNode;
  className?: string;
  btnType?: 'link' | 'button';
  /** 复制文本 */
  text: string;
  /** 复制提示语 */
  copyText?: string;
  /** 已复制提示语 */
  copiedText?: string;
  /** 文本按钮 */
  linkProps?: LinkProps;
  /** 按钮主题 */
  theme?: LinkProps['theme'];
  /** 图标大小 */
  iconSize?: number;
  /** 按钮 */
  buttonProps?: ButtonPropsType;
  /** 复制按钮点击事件 */
  onClick?: () => void;
};
function Copy(props: PropsType) {
  const {
    children,
    className,
    btnType = 'link',
    text,
    copyText = intlGet('COMMON.COPY'),
    copiedText = intlGet('COMMON.COPIED'),
    linkProps,
    theme = 'default',
    iconSize,
    buttonProps,
    onClick,
  } = props;
  const [isCopied, setIsCopied] = useState(false);

  const onCopy = () => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
    const timer = setTimeout(() => {
      setIsCopied(false);
      clearTimeout(timer);
    }, 1000);
  };

  // 自定义参数
  const customProps: any = useMemo(() => {
    return {
      className,
      theme,
      onClick: () => {
        onCopy();
        onClick?.();
      },
      tooltip: btnType === 'link' && (isCopied ? copiedText : copyText),
      tipProps: {
        theme: 'default',
        showArrow: false,
        overlayInnerStyle: { marginBottom: 5 },
      },
    };
  }, [className, theme, isCopied, copiedText, copyText, btnType, onClick]);

  useEffect(() => {
    if (btnType === 'button' && isCopied) {
      notification.success({ description: copiedText });
    }
  }, [isCopied]);

  return btnType === 'link' ? (
    <Link {...customProps} {...linkProps}>
      {children || <Icon.Font name="copy" fontSize={iconSize} />}
    </Link>
  ) : (
    <Button {...customProps} {...buttonProps}>
      {children || <Icon.Font name="copy" fontSize={iconSize} />}
    </Button>
  );
}

export default Copy;
